<div class="flex flex-col mx-16">
    <div class="flex">
        <h2
            class="w-1/2 p-4 text-center font-bold bg-gradient-to-t from-headerfr to-headerto leading-relaxed text-3xl my-10 px-12 text-yellow-100 py-4 rounded-lg">
            {{city}} Living Lab Identity Card
        </h2>
        <a [routerLink]="['']" class="w-1/2 p-4 flex justify-center items-center">
            <img class="w-1/4 hover:opacity-75" src="../assets/img/logo_fusilli_FINAL_web.svg">
        </a>
    </div>

    <div class="flex">
        <div id=label
            class="flex flex-row w-1/2 mx-1 text-white justify-center text-center font-semibold p-2 text-lg rounded-lg">
            Organizational Committee
        </div>
        <div id=label
            class="flex flex-row w-1/2 mx-1 text-white justify-center text-center font-semibold p-2 text-lg rounded-lg">
            Mission
        </div>
    </div>
    <div class="flex">
        <div class="w-1/2 p-4">
            <div *ngIf="this.allowed" class="font-light text-justify" [contentEditable]="edit"
                (blur)="onComitteeChange($event.target.innerHTML)" (focus)="onFocus()"
                [innerHTML]="comittee | noSanitize">{{comittee}}
            </div>
            <div *ngIf="!this.allowed" class="font-light text-justify" [innerHTML]="comittee | noSanitize">{{comittee}}
            </div>
        </div>
        <div class="w-1/2 p-4">
            <div *ngIf="this.allowed" class="font-light text-justify" [contentEditable]="edit"
                (blur)="onMissionChange($event.target.innerHTML)" (focus)="onFocus()"
                [innerHTML]="mission | noSanitize">{{mission}}
            </div>
            <div *ngIf="!this.allowed" class="font-light text-justify" [innerHTML]="comittee | noSanitize">{{mission}}
            </div>
        </div>
    </div>
    <!-- Objectives -->
    <div class="flex">
        <div class="flex flex-col w-full">
            <div id=label class="font-semibold p-2 text-white justify-center text-center rounded-lg">
                Objectives</div>
            <div class="p-4 font-light text-justify" *ngIf="this.allowed" [contentEditable]="edit"
                (blur)="onObjectivesChange($event.target.innerHTML)" (focus)="onFocus()"
                [innerHTML]="objectives | noSanitize">{{objectives}}
            </div>
            <div class="p-4 font-light text-justify" *ngIf="!this.allowed" [innerHTML]="objectives | noSanitize">
                {{objectives}}</div>
        </div>
    </div>
    <div class="flex">
        <div id=label
            class="flex flex-row w-1/2 mx-1 text-white justify-center text-center font-semibold p-2 text-lg rounded-lg">
            Living Lab Orientation
        </div>
        <div id=label
            class="flex flex-row w-1/2 mx-1 text-white justify-center text-center font-semibold p-2 text-lg rounded-lg">
            Target Groups
        </div>
    </div>
    <div class="flex">
        <div class="w-1/2 p-4">
            <div class="flex flex-wrap justify-around gap-6 p-4">
                <div *ngIf="orientation[0] !== '' || orientation[1] !== ''"
                    class="cia flex justify-center items-center custom-border">
                    <img src="../../../../../../assets/img/consumption.png" alt="consumption" class="w-12 h-12">
                </div>
                <div *ngIf="orientation[2] !== ''"
                    class="dia flex justify-center items-center text-center custom-border">
                    <img src="../../../../../../assets/img/distribution.png" alt="distribution" class="w-12 h-12">
                </div>
                <div *ngIf="orientation[3] !== ''"
                    class="gia flex justify-center items-center text-center custom-border">
                    <img src="../../../../../../assets/img/governance.png" alt="governance" class="w-12 h-12">
                </div>
                <div *ngIf="orientation[4] !== '' || orientation[5] !== ''"
                    class="pia flex justify-center items-center custom-border">
                    <img src="../../../../../../assets/img/production.png" alt="production" class="w-12 h-12">
                </div>
                <div *ngIf="orientation[6] !== ''"
                    class="wia flex justify-center items-center text-center custom-border">
                    <img src="../../../../../../assets/img/waste.png" alt="waste" class="w-12 h-12">
                </div>
            </div>

        </div>
        <div class="w-1/2 p-4">
            <div *ngIf="this.allowed" class="font-light text-justify" [contentEditable]="edit"
                (blur)="onGroupsChange($event.target.innerHTML)" (focus)="onFocus()" [innerHTML]="groups | noSanitize">
                {{groups}}
            </div>
            <div *ngIf="!this.allowed" class="font-light text-justify" [innerHTML]="groups | noSanitize">
                {{groups}}</div>
        </div>
    </div>
    <div class="flex">
        <div class="flex flex-col w-full">
            <div class="flex justify-center">
                <div id="label"
                    class="w-full font-semibold p-2 text-white justify-center text-center rounded-lg relative">
                    Main Actions
                </div>
                <button id="btn" matTooltip="See the project outcomes of the {{city}} Living Lab here "
                    matTooltipClass="text-lg" (click)="onInfo()"
                    class="absolute right-0 mr-4 font-light rounded h-3/4 px-4 py-2 text-white flex items-center">
                    <i class="fas fa-info text-3xl"></i>
                </button>
            </div>
            <div class="p-2">
                <ng-container *ngFor="let category of actions; let i = index">
                    <div class="flex items-start font-semibold"
                        [ngClass]="{'flex-row': isOdd(i), 'flex-row-reverse': !isOdd(i)}">
                        <div [ngClass]="['custom-border', getCategoryClass(category.category)]"
                            class="flex-shrink-0 w-24 h-24 flex justify-center items-center mr-4">
                            <img *ngIf="getCategoryImage(category.category)" [src]="getCategoryImage(category.category)"
                                matTooltip="{{category.category}}" matTooltipClass="text-xl" alt="category image"
                                class="w-12 h-12">
                        </div>
                        <div class="flex flex-col">
                            <div *ngFor="let action of category.actions" class="font-light p-2 my-1">
                                <div class="mx-2">{{ action.action.substring(6) }}</div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- Impacts -->
    <div class="flex">
        <div class="flex flex-col w-full">
            <div id=label
                class="flex flex-row w-full mx-1 text-white justify-center text-center font-semibold p-2 text-lg rounded-lg">
                Most Relevant Impacts as a result of actions implementation</div>
            <div class="impacts-bar">
                <ng-container *ngFor="let impact of impacts">
                    <div class="impact-item">
                        {{impact}}
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- Save Button -->
    <div *ngIf="this.edited">
        <button class="float-right px-4 py-2 mt-4 bg-green-600 text-white rounded shadow hover:bg-green-700"
            (click)="onSave()">
            Save changes
        </button>
    </div>
</div>